import { FutureEntriesModalTranslations } from "./future-entries-modal-pt-br";

export const FUTURE_ENTRIES_MODAL_ES_MX: FutureEntriesModalTranslations = {
	title: "Entradas Futuras",
	search: "Buscar",
	return: "Volver",
	totalEntries: "{{count}} entrada",
	totalEntries_plural: "{{count}} entradas",
	totalForMonth: "Total de Entradas",
	columns: {
		month: "Mes",
		group: "AGRUPACIÓN",
		total: "Total",
		type: "TIPO",
		category: "CATEGORÍA",
		originDestination: "ORIGEN/DESTINO",
		observation: "OBSERVACIÓN",
		competenceDate: "FECHA DE COMPETENCIA",
		liquidationDate: "FECHA DE LIQUIDACIÓN",
		value: "VALOR",
		totalReleases: "Total de Entradas",
		emptyText: "No se encontraron entradas futuras",
	},
	excel: {
		title: "Entradas Futuras - {{startDate}} a {{endDate}}",
		fileName: "entradas-futuras-{{startDate}}-{{endDate}}",
	},
};
